import { render, staticRenderFns } from "./livingUpdate_settlement.vue?vue&type=template&id=0f32ae4f&scoped=true&"
import script from "./livingUpdate_settlement.vue?vue&type=script&lang=js&"
export * from "./livingUpdate_settlement.vue?vue&type=script&lang=js&"
import style0 from "./livingUpdate_settlement.vue?vue&type=style&index=0&id=0f32ae4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32ae4f",
  null
  
)

export default component.exports